import { withI18n } from 'react-i18next';
import RCheckbox from './RCheckbox';

export const pureComponent = RCheckbox;
export default withI18n()(RCheckbox);
